module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/transaction/transaction-edit/transaction-edit.component.scss
// module id = ./src/app/transaction/transaction-edit/transaction-edit.component.scss
// module chunks = main